export const estadosEmpleado = [
    {
        id: 1,
        nombre: "Activo"
    },
    {
        id: 0,
        nombre: "Inactivo"
    }
]